import { z } from 'zod';
import { ResourceVersionSchema } from './concurrency.js';
/**
 * Respuesta guardada de una operación idempotente (docs/migration/08 §4.11 y 09 §5).
 * **Minimizada**: solo identificador, estado y versión. El estado es un código en MAYÚSCULAS
 * (p. ej. `PENDING_APPROVAL`), nunca texto libre. Sin datos personales.
 */
export const IdempotentResponseSchema = z.strictObject({
    id: z.uuid(),
    status: z.string().regex(/^[A-Z][A-Z0-9_]{0,63}$/),
    version: ResourceVersionSchema,
});
//# sourceMappingURL=idempotency.js.map